export function getMBNIndicationClassHelper(MBNNumber) {
    switch (MBNNumber) {
        case "1": return "min-bet-number--one";
        case "2": return "min-bet-number--two";
        case "3": return "min-bet-number--three";
        default: return "";
    }
}
//# sourceMappingURL=getMBNIndicationClassHelper.js.map